import React, { useState } from "react";
import {
  Button,
  Col,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Label,
  Row,
} from "reactstrap";
import clearIcon from "assets/icon/clearIcon.svg";
import Calender from "assets/icon/calenderBlack.svg";
import DatePicker from "react-datepicker";
import moment from "moment";
import ReactInputMask from "react-input-mask";
import searchIcon from "assets/icon/searchBlank.svg";
import { Field, Formik } from "formik";

const AddMedicalCondition = ({
  medicalCondition,
  setMedicalCondition,
  diagnosedDate,
  setDiagnosedDate,
}) => {
  // const [diagnosedDate, setDiagnosedDate] = useState("");
  const [focusedInput, setFocusedInput] = useState("");
  const [error, setError] = useState(false);

  const [searchText, setSearchText]=useState('');
  const [provider, setProvider]=useState('');
  let hasDatePopupOpen = false;
  const handleMouseLeave = () => {
    hasDatePopupOpen = false;
  };

  const handleBlur = () => {
    setFocusedInput("");
  };

  const handleStartDate = (diagnosedDate) => {
    if (diagnosedDate !== null) {
      const date = moment(diagnosedDate, "MM/DD/YYYY", true);
      if (date.isValid()) {
        setDiagnosedDate(date.toDate());
        // SearchTerms.diagnosedDate=diagnosedDate
      }
    } else {
      setDiagnosedDate(null);
      // SearchTerms.diagnosedDate=null
    }
  };
  const handleStartDateRaw = (e) => {
    var val = e.target.value;
    if (val == "__/__/____" && diagnosedDate !== null) {
      setDiagnosedDate(null);
      setError(false);
      //SearchTerms.diagnosedDate = null;
    }
    if (val !== undefined && val.length == 10 && val.indexOf("_") == -1) {
      handleStartDate(e.target.value);
      //SearchTerms.diagnosedDate = val;
    }
  };

  const handleFocus = (inputName) => {
    setFocusedInput(inputName);
  };
  const stepNum = 2;
  const numSteps = 9;
  const step = [
    { title: "Patient", time: "13:21", date: "02/06/2025" },
    { title: "Patient", time: "13:21", date: "02/06/2025" },
  ];

  const handleDateClick = (id) => {
    if (hasDatePopupOpen) {
      hasDatePopupOpen = false;
      return;
    }
    const calendarButton = document.getElementById(id);
    if (calendarButton) {
      calendarButton.click();
      hasDatePopupOpen = true;
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setMedicalCondition({ ...medicalCondition, [name]: value });
  };

  return (
    <>
      <div style={{ width: "50vw", paddingLeft: "20px", paddingRight: "12px" }}>
        <Row>
          <Col sm={6} md={6} lg={6} className="required-date ">
            <Label>
              <span className="text-danger">*</span> Medical Condition
            </Label>
            <InputGroup onMouseLeave={handleMouseLeave} className="date-14px">
              <Input type="text" placeholder="Search by condition name" value={searchText} onChange={(e)=>setSearchText(e.target.value)} />
              <InputGroupText>
                <InputGroupText style={{ cursor: "pointer" }}>
                  {searchText ? (
                  
                      <img src={clearIcon} onClick={()=>setSearchText('')}/>
                  ) : (
                    <img src={searchIcon} alt="Search" />
                  )}
                </InputGroupText>
              </InputGroupText>
            </InputGroup>
          </Col>
          <Col sm={12} md={6}>
            <Label className="mbb-8 add-clinic">ICD-10</Label>
            <Formik>
              <FormGroup className="controls textarea_info search-flex mb-0">
                <InputGroup>
                  <Input
                    as="select"
                    id="option"
                    name="allergy"
                    placeholder="-"
                    className="order-detail-input"
                    value=""
                    onChange={handleChange}
                  />
                </InputGroup>
              </FormGroup>
            </Formik>
          </Col>
        </Row>
        <Row className="mt-2">
          <Col sm={12} md={6}>
            <Label className="mbb-8 add-clinic">
              <span className="text-danger">*</span> Status
            </Label>
            <Formik>
              <FormGroup className="controls textarea_info search-flex mb-0">
                <InputGroup>
                  <Field
                    as="select"
                    id="option"
                    name="allergy"
                    className="order-detail-input"
                    value={medicalCondition.allergy}
                    onChange={handleChange}
                  >
                    <option value="" label="Select Status" />
                    <option value="option1" label="Drug" />
                    <option value="option2" label="Food" />
                    <option value="option3" label="Chemical" />
                    <option value="option3" label="Environmental allergy" />
                  </Field>
                </InputGroup>
              </FormGroup>
            </Formik>
          </Col>
          <Col sm={6} md={6} lg={6} className="required-date ">
            <Label>Diagnosing Provider</Label>
            <InputGroup className="date-14px">
              <Input type="text" placeholder="Search by provider name" value={provider} onChange={(e)=>setProvider(e.target.value)}/>
              <InputGroupText>
                {provider ? (
                  
                      <img src={clearIcon} onClick={()=>setProvider('')}/>
                  ) : (
                    <img src={searchIcon} alt="Search" />
                  )}
              </InputGroupText>
            </InputGroup>
          </Col>
        </Row>
        <Row className="mt-2">
          <Col sm={6} md={6} lg={6} className="required-date ">
            <Label>Diagnosis Date</Label>
            <InputGroup onMouseLeave={handleMouseLeave} className="date-14px">
              <DatePicker
                id="diagnosedDate"
                name="diagnosedDate"
                selected={diagnosedDate}
                onChange={(diagnosedDate) => handleStartDate(diagnosedDate)}
                onFocus={() => handleFocus("StartDate")}
                onBlur={handleBlur}
                isClearable
                onChangeRaw={handleStartDateRaw}
                dateFormat="MM/dd/yyyy"
                placeholderText="select"
                autoComplete="off"
                customInput={
                  <ReactInputMask mask="99/99/9999" value={diagnosedDate} />
                }
              />
              <InputGroupText onClick={() => handleDateClick("diagnosedDate")}>
                <img src={Calender} alt="" />
              </InputGroupText>
            </InputGroup>
          </Col>

          <Col sm={6} md={6} lg={6} className="required-date ">
            <Label>Date Resolved</Label>
            <InputGroup onMouseLeave={handleMouseLeave} className="date-14px">
              <DatePicker
                id="diagnosedDate"
                name="diagnosedDate"
                selected={diagnosedDate}
                onChange={(diagnosedDate) => handleStartDate(diagnosedDate)}
                onFocus={() => handleFocus("StartDate")}
                onBlur={handleBlur}
                isClearable
                onChangeRaw={handleStartDateRaw}
                dateFormat="MM/dd/yyyy"
                placeholderText="select"
                autoComplete="off"
                customInput={
                  <ReactInputMask mask="99/99/9999" value={diagnosedDate} />
                }
              />
              <InputGroupText onClick={() => handleDateClick("diagnosedDate")}>
                <img src={Calender} alt="" />
              </InputGroupText>
            </InputGroup>
          </Col>
        </Row>
        <div
          style={{
            border: "1px solid #D3D3D3",
            margin: "16px 0px 0px 0px",
          }}
        ></div>
        <Row className="mt-2">
          <Col sm={12} md={12}>
            <Label className="mbb-8 add-clinic">Information Source </Label>
            <Formik>
              <FormGroup className="controls textarea_info search-flex mb-0">
                <Input
                  style={{ border: "1px soild" }}
                  className="textlength"
                  type="textarea"
                  placeholder="Describe how the information was obtained"
                  value={medicalCondition.conditions}
                  name="conditions"
                  onChange={handleChange}
                />
              </FormGroup>
            </Formik>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default AddMedicalCondition;
